import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/cwd/frontend_Arbaz/cwd-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_Arbaz/cwd-website/src/components/NotFound/index.tsx");
